import { reverse } from 'named-urls';
import { matchPath } from 'react-router-dom';

import { entries, getServerObject, parseSearchParams } from './common';
import { defaultLang, availableLanguages } from './constants';
import routes from '../routes';

export function getPaymentPostParams() {
  const serverObject = getServerObject();

  if (serverObject && serverObject.hasOwnProperty('post_params')) {
    return serverObject.post_params;
  }
}

export function getPaymentInvoiceResult() {
  const serverObj = getServerObject();

  if (serverObj && serverObj.hasOwnProperty('result_type')) {
    return serverObj;
  }
}

export function getPaymentParams() {
  const postParams = getPaymentPostParams();

  let payment;
  if (postParams) {
    payment = postParams;
  } else {
    payment = parseSearchParams(window.location.search.substring(1));
  }

  return payment;
}

export function getErrorText(translation, errorCode, prefix = '', params) {
  prefix = prefix ? prefix + '.' : '';

  return translation(
    [`${prefix}Errors.${errorCode}`, `${prefix}Errors.Default`, 'DefaultError'],
    params
  );
}

export function validateAddOn(addOnTemplate, value) {
  const { regex, prefix, optional } = addOnTemplate;

  if (optional && (value == null || value === '')) {
    return true;
  }

  if (typeof value == 'undefined') {
    return false;
  }

  if (typeof regex == 'undefined') {
    return true;
  }

  if (typeof prefix != 'undefined' && value.indexOf(prefix) === 0) {
    value = value.slice(prefix.length);
  }

  return new RegExp(regex).test(value);
}

export function validateAddOns(addOnsTemplate, addOns) {
  if (!addOnsTemplate || Object.keys(addOnsTemplate).length === 0) {
    return true;
  }

  return !entries(addOnsTemplate).find(
    ([name, addOnTemplate]) => !validateAddOn(addOnTemplate, addOns[name])
  );
}

export function stripPathFromLng(pathname) {
  let path = pathname;

  if (pathname.startsWith('/')) {
    path = path.substr(1);
  }

  const found = availableLanguages.find((l) => path.startsWith(l + '/'));

  if (found) {
    return path.substr(found.length);
  } else {
    return pathname;
  }
}

export function initUrlFor(lng) {
  lng = availableLanguages.indexOf(lng) === -1 ? defaultLang : lng;

  return function urlFor(name, params) {
    const route = routes.find((route) => route.name === name);

    if (typeof route == 'undefined') {
      throw new Error('Invalid route name');
    }
    return `/${lng}${reverse(route.path, params)}`;
  };
}

export function matchRoute(pathname) {
  pathname = stripPathFromLng(pathname);

  const route = routes.find(
    (route) =>
      matchPath({ path: route.path, end: route.exact }, pathname) !== null
  );

  return route && route.name;
}

export function readableNumber(f, precision) {
  if (f == null) return;

  const n = Number(f);
  return parseFloat(
    n.toFixed(typeof precision == 'undefined' ? (n < 0.01 ? 6 : 2) : precision)
  );
}
